import React from 'react'
import TextRow from '../Rows/TextRow'
import { Shadow } from '../../types/Shadow.types'
import { FormTabProps } from '../../types/FormTab.types'

const DeviceConfigurationSection = ({ formState, handleChangeByShadow }: FormTabProps) => {
    const inputChanged = handleChangeByShadow(Shadow.System);

    return (
        <>
            <TextRow
                label="Wybór strefy czasowej"
                caption="TZ_DATABASE_NAME"
                name="system.TZ_DATABASE_NAME"
                value={formState.system?.TZ_DATABASE_NAME}
                onChange={inputChanged}
            />

            <TextRow
                label="Konfiguracja NTP"
                caption="NTP_SERVERS"
                name="system.NTP_SERVERS"
                value={formState.system?.NTP_SERVERS}
                onChange={inputChanged}
            />

        </>
    )
}

export default DeviceConfigurationSection
